import { boolean, defineAction, number, object, string } from '~/prix'
import synchronizeAppSebraeV2BackfillAction from './synchronizeAppSebraeV2Backfill.action.json'

const synchronizeAppSebraeV2BackfillDefinition = defineAction({
  ...synchronizeAppSebraeV2BackfillAction,
  input: object({
    id: string().isOptional(),
    year: number().isOptional(),
    limit: number().isOptional(),
    force: boolean().isOptional(),
    verbose: boolean().isOptional(),
    onlyMissing: boolean().isOptional(),
    skipInternalGeocoding: boolean().isOptional(),
    dryRun: boolean().isOptional(),
  }),
  output: object({
    success: boolean(),
    queued: boolean(),
    dryRun: boolean(),
    total: number(),
    selected: number(),
    processed: number(),
    warnings: number(),
    errorCount: number(),
  }),
})

export default synchronizeAppSebraeV2BackfillDefinition
